export default 'SEND_FROM_EDIT_PAGE';
